<template>
    <div
        v-if="filters && filters.length > 0"
        class="m-filters"
    >
        <a-button
            icon="RemoveLight"
            class="a-button--small a-button--darkGrey m-filters__filterRemove"
            @click="$emit('remove-all')"
        >
            Usuń filtry
        </a-button>
        <a-button
            v-for="filter in filters"
            v-bind:key="filter.value"
            class="a-button--grey a-button--small m-filters__filter"
            @click="$emit('remove-filter', filter.name)"
        >
            {{ filter.value }}
            <a-icon
                icon="CloseSmall"
                class="m-filters__removeIcon"
            />
        </a-button>
    </div>
</template>

<script>
export default {
    props: {
        filters: {
            type: Array,
            required: true
        }
    }
}
</script>